"use strict";

var React = require("react");

var SvgIconCheckboxSelectedV1 = function SvgIconCheckboxSelectedV1() {
  return /*#__PURE__*/ React.createElement(
    "svg",
    {
      width: "1em",
      height: "1em",
      viewBox: "0 0 12 12",
    },
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      d:
        "M10.667 0H1.333C.6 0 0 .6 0 1.333v9.334C0 11.4.6 12 1.333 12h9.334C11.4 12 12 11.4 12 10.667V1.333C12 .6 11.4 0 10.667 0zM1 6.154l1-1.077 2.571 2.77L10 2l1 1.077L4.571 10 1 6.154z",
    })
  );
};

exports["foreignIcon"] = SvgIconCheckboxSelectedV1;
